import {IPromoCode, IPromoCodeData} from "./index";
import {Category} from "../..";

export class PromoCode implements IPromoCode {
  readonly id?: number;
  readonly value: number;
  readonly price: number;
  readonly category: Category;

  constructor(data: IPromoCodeData) {
    this.id = data.id;
    this.value = data.value;
    let price = data?.price;
    price = (typeof price === 'string') ? parseFloat(price) : price
    this.price = price || 0
    this.category = data.category;
  }

  validate(): boolean {
    return this.value > 0 && this.value <= 100;
  }

}
